import { Component, NgZone } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { Network } from '@capacitor/network';
import { Platform, ToastController } from '@ionic/angular';
import { AppUpdateService } from './services/app-update.service';
import { SessionService } from './services/session.service';
import { ToastrService } from './services/toastr.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  constructor(
    private platform: Platform,
    private toastr: ToastrService,
    private sessionService: SessionService,
    private router: Router,
    private update: AppUpdateService
  ) {
    ////check connection///
    this.toastr.initoalToaster("welcome");

    Network.addListener('networkStatusChange', status => {
      this.sessionService.netConnection = status.connected;
      if (this.sessionService.netConnection) {
        this.toastr.presentToastWithOptionsDismiss();
      } else {
        this.toastr.noInternet();
      }
    });

    this.sessionService.AppOpend = true;
    if (!this.sessionService.AppOpend) {
      this.router.navigate(["/landing"]);
    }
  }
}
